import { routePaths } from 'appConfig';
import HeaderSEO from 'components/HeaderSEO';
import {
  Container,
  ManualBreadcrumb,
  ManualBreadcrumbItem,
  Page,
} from 'components/common';
import {
  Catalogue,
  CatalogueItems,
  getCatalogueByIdOrSlug,
} from 'lib/catalogues';
import { GetServerSideProps } from 'next';
import React from 'react';

interface CataloguePageProps {
  catalogue: Catalogue;
}

const CataloguePage = ({ catalogue }: CataloguePageProps) => {
  const firstProductImage = catalogue.items?.[0]?.image_url;

  return (
    <Page
      breadcrumb={
        <ManualBreadcrumb>
          <ManualBreadcrumbItem href={routePaths.HOME}>
            Home
          </ManualBreadcrumbItem>
          <ManualBreadcrumbItem active>
            {catalogue.title}
          </ManualBreadcrumbItem>
        </ManualBreadcrumb>
      }
      content={
        <React.Fragment>
          <HeaderSEO
            title={`Yummy Bros - ${catalogue.title}`}
            description=""
            path={`https://www.yummybros.com/catalogues/${catalogue.slug}`}
            image={firstProductImage ?? ''}
            ogType="article"
          />
          <Container>
            <CatalogueItems items={catalogue.items} />
          </Container>
        </React.Fragment>
      }
    />
  );
};

export const getServerSideProps: GetServerSideProps<{
  catalogue: Catalogue;
}> = async (context) => {
  const { slugOrCatalogueId } = context.query ?? {};

  try {
    const catalogue: Catalogue = await getCatalogueByIdOrSlug(
      slugOrCatalogueId?.toString() ?? '',
    );

    return {
      props: {
        catalogue,
      },
    };
  } catch {
    return { notFound: true };
  }
};

export default CataloguePage;
